/**
 * Luxury footer motion (styles in footer-luxe.css): gold edge line, giant wordmark that drifts with
 * scroll, staggered reveal of the footer columns, and a back-to-top button.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function init() {
  const footer = document.querySelector('footer.lux-footer');
  if (!footer || footer.dataset.lfInit) return;
  footer.dataset.lfInit = 'true';

  // Decorative layers
  const edge = document.createElement('span');
  edge.className = 'lux-footer__edge';
  edge.setAttribute('aria-hidden', 'true');

  const wordmark = document.createElement('span');
  wordmark.className = 'lux-footer__wordmark';
  wordmark.setAttribute('aria-hidden', 'true');
  wordmark.textContent = 'STERLING TOMORROW';

  footer.prepend(edge, wordmark);

  // Back to top, in the bottom bar
  const bar = footer.querySelector('.footer-utilities .utilities');
  if (bar) {
    const top = document.createElement('button');
    top.type = 'button';
    top.className = 'lux-footer__top';
    top.setAttribute('aria-label', 'Back to top');
    top.innerHTML =
      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 13V3M3.5 7.5 8 3l4.5 4.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' }));
    bar.appendChild(top);
  }

  if (reducedMotion || !('IntersectionObserver' in window)) return;

  // Staggered reveal: brand, each link column, newsletter pieces, bottom bar
  const targets = [
    ...footer.querySelectorAll('.footer-logo-image, rte-formatter, .footer-link-group, .email-signup-block, .divider, .footer-utilities .utilities'),
  ];
  targets.forEach((el, index) => {
    el.classList.add('lf-reveal');
    el.style.setProperty('--lf-delay', `${Math.min(index, 8) * 90}ms`);
  });
  footer.classList.add('lf-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
  );
  targets.forEach((el) => observer.observe(el));

  // Wordmark drifts sideways as the footer scrolls through the screen
  let queued = false;
  const drift = () => {
    queued = false;
    const rect = footer.getBoundingClientRect();
    if (rect.top > window.innerHeight || rect.bottom < 0) return;
    const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
    footer.style.setProperty('--lf-drift', ((progress - 0.5) * -160).toFixed(1));
  };
  window.addEventListener(
    'scroll',
    () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(drift);
    },
    { passive: true }
  );
  drift();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
